import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
// Constants
import { pathHomePage } from "../config/constants";
// Components
import SignIn from "../views/SignIn";
import Home from "../views/Home";
import AddPatient from "../views/Patient-Add";
import EditPatient from "../views/Patient-Edit";
import PrescriptionsClinic from "../views/Prescriptions/clinic";
import PrescriptionsHome from "../views/Prescriptions/home";
import Reports from "../views/Reports";
import Settings from "../views/Settings";
import FirstLogin from "../views/First-Login";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path={`/`} component={SignIn} exact />
      <Route path={`${pathHomePage}/home/:clinicianToken`} component={Home} />
      <Route path={`${pathHomePage}/add-patient/:clinicianToken`} component={AddPatient} />
      <Route path={`${pathHomePage}/edit-patient/:clinicianToken/:patientId`} component={EditPatient} />
      <Route path={`${pathHomePage}/prescriptions/clinic/:clinicianToken/:patientId`} component={PrescriptionsClinic} />
      <Route path={`${pathHomePage}/prescriptions/home/:clinicianToken/:patientId`} component={PrescriptionsHome} />
      <Route path={`${pathHomePage}/reports/:clinicianToken/:software/:patientId/:protocolId`} component={Reports} />
      <Route path={`${pathHomePage}/settings/:clinicianToken`} component={Settings} />
      <Route path={`${pathHomePage}/validate-password/:clinicianToken`} component={FirstLogin} />
      {/* redirect user to SignIn page if route does not exist and user is not authenticated */}
      <Route component={SignIn} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
